import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import Loader from "./Loader";

import "react-html5-camera-photo/build/css/index.css";

function Capture(props) {
  const {
    coords,
    user,
    setSection,
    getMapData,
    description,
    coneAmount,
    setDescription,
    setConeAmount,
    killTimer,
    startTimer
  } = props;

  const [dataUri, setDataUri] = useState("");
  const [open, setOpen] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [saveMessage, setSaveMessage] = useState("Saving");
  const [coneError, setConeError] = useState(false);


  // ✅ NEW STATE
  const [limitReached, setLimitReached] = useState(false);

  const openExternal = (url) => {
    const ua = navigator.userAgent || "";

    const isWebView =
      ua.includes("wv") ||
      (ua.includes("Android") && !ua.includes("Chrome")) ||
      (ua.includes("iPhone") && !ua.includes("Safari"));

    if (isWebView) {
      // mobile app
      window.location.href = url;
    } else {
      // browser
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };


  const captureSectionWrapper = document.querySelector(".captureSectionWrapper");

  useEffect(() => {

    if (!user) return;

    const checkLimit = async () => {

      try {

        const response = await fetch(
          `https://findmycones.com:46508/api/check-limit?owner_id=${user.userId}&org_id=${user.orgId}`,
          {
            headers: {
              "x-api-key": "fa57386dc4f772b69a750f06cb408"
            }
          }
        );

        const data = await response.json();

        setLimitReached(data.limitReached);

      }
      catch (err) {
        console.log("Limit check failed", err);
      }

    };

    checkLimit();

  }, [user]);





  const handleClose = () => {
    setOpen(false);
    setDataUri("");
    setConeAmount("");
    setConeError(false);
    setDescription("");
  };

  const handleOpen = () => {

    // ✅ NEW: prevent camera open if limit reached
    if (limitReached) return;

    killTimer();
    setOpen(true);

    if (captureSectionWrapper)
      captureSectionWrapper.style.backgroundColor = "#00000055";
  };

  const handleShowMap = () => {
    startTimer();
    setDataUri("");
    setConeAmount("");
    setConeError(false);
    setDescription("");
    setSection(1);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleConeChange = (e) => {

    const value = e.target.value;

    if (value === "") {
      setConeAmount("");
      setConeError(false);
      return;
    }

    const targetInt = Number(value);

    if (Number.isNaN(targetInt)) {
      setConeError(true);
    } else {
      setConeError(false);
      setConeAmount(targetInt);
    }
  };

  const handleTakePhoto = (data) => {
    setDataUri(data);
    setOpen(false);

    if (captureSectionWrapper)
      captureSectionWrapper.style.backgroundColor = "transparent";
  };

  const handleCloseCamera = () => {
    setOpen(false);

    if (captureSectionWrapper)
      captureSectionWrapper.style.backgroundColor = "transparent";
  };


  const handleSave = () => {

    if (dataUri === "") {
      alert("You must take a picture before you can save!");
    }
    else if (description === "") {
      alert("You must enter a decsription");
    }
    else if (coneError || coneAmount === "") {
      alert("You must enter a cone amount");
    }
    else {

      setShowLoader(true);

      let dataCode = (Math.random() + 1).toString(36).substring(2);

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("x-api-key", "fa57386dc4f772b69a750f06cb408");

      var raw = JSON.stringify({
        lat: `${coords.lat}`,
        lng: `${coords.lng}`,
        dataUri: dataUri,
        dataCode: `${dataCode}`,
        description: `${description === "" ? "None" : description}`,
        status: 1,
        owner_id: user.userId,
        org_id: `${user.orgId !== 0 ? user.orgId : 0}`,
        cones_left: coneAmount,
        cones_remaining: coneAmount
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const doFinalizeSave = () => {
        setDataUri("");
        handleClose();
        setTimeout(() => {
          getMapData();
          setSection(1);
        }, 500);
      };

      // fetch("https://findmycones.com:46508/api/submit", requestOptions)
      //   // fetch("http://localhost:46508/api/submit", requestOptions)
      //   .then((response) => response.json())
      //   .then((json) => {

      //     // ✅ KEEP ORIGINAL CLIENT LOGIC
      //     if (Object.values(json).some(value => value === 'nosub')) {
      //       window.location.href = "https://findmycones.com/prices";
      //       throw new Error('Max Cone Limit Reached')
      //     }

      //     return json;
      //   })

      fetch("https://findmycones.com:46508/api/submit", requestOptions)
        // fetch("https://localhost:46508/api/submit", requestOptions)
        .then(async (response) => {

          const json = await response.json();

          if (!response.ok) {

            if (json.error === "conelimit") {
              setLimitReached(true);
              throw new Error("Max Cone Limit Reached");
            }

            throw new Error("Server error");
          }

          return json;
        })

        .then((json) => {

          if (Object.values(json).some(value => value === 'nosub')) {

            setLimitReached(true);  // THIS is correct source of truth

            throw new Error('Max Cone Limit Reached');
          }

          return json;

        })

        .then(() => {
          setSaveMessage("Saved!");

          // ✅ recheck limit immediately
          // checkLimit();

          setTimeout(() => {
            setShowLoader(false);
          }, 2000);

          doFinalizeSave();
        })

        .catch((error) => {

          setSaveMessage(`An Error Ocurred: ${error}`);

          setTimeout(() => {
            setShowLoader(false);
          }, 10000);

          doFinalizeSave();

          console.log("error", error)

        });
    }
  };

  const goToPlans = () => {
    openExternal("https://findmycones.com/prices");
  };


  return (
    <div className="captureSectionWrapper">

      <Loader open={showLoader} message={saveMessage} />

      {/* ✅ NEW: LIMIT MESSAGE */}
      {limitReached && (
        <Box
          sx={{
            width: "75vw",
            margin: "40px auto",
            padding: "25px",
            backgroundColor: "#fff3f3",
            border: "1px solid #ffcccc",
            borderRadius: "8px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "15px"
          }}
        >
          <div style={{ color: "#d32f2f", fontWeight: "bold", fontSize: "18px" }}>
            Maximum Cones Reached!
          </div>

          <div style={{ color: "#d32f2f", fontWeight: "normal", fontSize: "15px" }}>
            You’ve hit your free limit of 10 locations. To add more and unlock unlimited tracking, check out our <span style={{ fontWeight: "bold", color: "#6366f1", }}>Premium Plans</span>.
          </div>

          <Stack
            // This is the magic part: column on mobile (xs), row on tablets+ (sm)
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{ width: "100%", justifyContent: "center" }}
          >

            <Button
              variant="contained"
              onClick={goToPlans}
            >
              View Plans
            </Button>

            <Button
              variant="outlined"
              onClick={handleShowMap}
            >
              Back to Map
            </Button>

          </Stack>

        </Box>
      )}


      {!limitReached && (
        <>
          {open === true ? (
            <div
              onClick={handleCloseCamera}
              style={{
                position: "fixed",
                inset: 0,
                background: "transparent",
                zIndex: 10,

                /* center camera */
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Camera
                  sizeFactor={0.3}
                  imageCompression={1}
                  imageType={IMAGE_TYPES.JPG}
                  idealResolution={{ width: 500, height: 375 }}
                  onTakePhoto={(dataUri) => {
                    handleTakePhoto(dataUri);
                  }}
                  idealFacingMode={FACING_MODES.ENVIRONMENT}
                  isFullscreen={false}
                />
              </div>
            </div>
          ) : null}



          <Box
            onClick={handleOpen}
            sx={{
              width: "75vw",
              height: "25%",
              border: dataUri ? "1px solid grey" : "2px dashed grey",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              textAlign: "center",
            }}
          >
            {dataUri ? (
              <img
                className="imagePreview"
                alt=""
                style={{ width: "75vw", height: "75vw", objectFit: "fill" }}
                src={dataUri}
              />
            ) : (
              <div>
                <CameraAltIcon />
                <div>Capture Photo</div>
              </div>
            )}
          </Box>

          <Stack spacing={1}>
            <TextField
              value={coords.lat}
              label="Latitude"
              variant="outlined"
              style={{ width: "75vw" }}
            />

            <TextField
              value={coords.lng}
              label="Longitude"
              variant="outlined"
            />

            <TextField
              label="Description"
              variant="outlined"
              value={description}
              onChange={handleDescriptionChange}
            />

            <TextField
              onChange={handleConeChange}
              label="Number of cones left onsite"
              error={coneError}
              value={coneAmount}
              placeholder="0"
            />
          </Stack>

          <Stack direction="row" spacing={2}>
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>

            <Button variant="contained" onClick={handleShowMap}>
              Cancel
            </Button>
          </Stack>
        </>
      )}


    </div>
  );
}

export default Capture;
